import { render, staticRenderFns } from "./DutyUi.vue?vue&type=template&id=c77d4f82"
import script from "./DutyUi.vue?vue&type=script&lang=ts"
export * from "./DutyUi.vue?vue&type=script&lang=ts"
import style0 from "./dutyui.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DutyUi.vue?vue&type=style&index=1&id=c77d4f82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports